'use client';

import { TextPassage } from '@petsmart-ui/sparky';
import type { ReactElement } from 'react';
import { useId } from 'react';

export type CountdownBarProps = {
    /** Progress toward `total` (e.g. qualifying cart amount toward the free-shipping threshold). Clamped to `[0, total]`; full bar when equal to `total`. */
    readonly value: number;
    readonly total: number;
    /** Visible text (e.g. threshold or goal) shown instead of a percentage. */
    readonly endLabel: string;
    /** Visible text shown to the left of the progress bar (e.g. the starting value). */
    readonly startLabel: string;
    readonly className?: string;
};

export function CountdownBar({ value, total, endLabel, startLabel, className = '' }: CountdownBarProps): ReactElement {
    const labelId = useId();
    const safeTotal = total > 0 ? total : 1;
    const safeValue = Math.min(Math.max(0, value), safeTotal);

    return (
        <div className={`countdown-bar ${className}`.trim()} data-testid="countdown-bar">
            <TextPassage className="countdown-bar__label">{startLabel}</TextPassage>
            <progress className="countdown-bar__progress" value={safeValue} max={safeTotal} aria-labelledby={labelId} />
            <TextPassage id={labelId} className="countdown-bar__label">
                {endLabel}
            </TextPassage>
        </div>
    );
}
